import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./ToolModal.module.css";
import NotepadTool from "./NotepadTool";
import PaintTool from "./PaintTool";

const ToolModal = ({ show, onHide, tool }) => {
  const notepadRef = useRef(null);
  const paintRef = useRef(null);
  const notepadId = useRef("toolbar-notepad-main").current;
  const paintId = useRef("toolbar-paint-main").current;
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleClose = () => {
    notepadRef.current?.save();
    paintRef.current?.save();
    onHide();
  };

  const toggleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
  };

  const title = tool === "notepad" ? "Notepad" : "Rəsm";

  return (
    <Modal show={show} onHide={handleClose} centered={!isFullscreen} size={isFullscreen ? undefined : "lg"} fullscreen={isFullscreen} dialogClassName={isFullscreen ? "" : styles.resizableDialog} contentClassName={isFullscreen ? "" : styles.resizableContent}>
      <Modal.Header style={{ background: "var(--color-surface)", borderBottom: "1px solid var(--color-border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Modal.Title className="d-flex align-items-center gap-2" style={{ fontWeight: 700, fontSize: 18, color: "var(--color-text)" }}>
          <i className={`bi ${tool === "notepad" ? "bi-journal-text" : "bi-palette2"}`} style={{ color: "var(--color-primary)" }} />
          {title}
        </Modal.Title>
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="light"
            size="sm"
            onClick={toggleFullscreen}
            title={isFullscreen ? "Normal ölçüyə keç" : "Tam ekrana keç"}
          >
            <i className={`bi ${isFullscreen ? "bi-fullscreen-exit" : "bi-fullscreen"}`} />
          </Button>
          <Button
            variant="light"
            size="sm"
            onClick={handleClose}
            aria-label="Bağla"
          >
            <i className="bi bi-x-lg" />
          </Button>
        </div>
      </Modal.Header>

      <Modal.Body className="p-0" style={{ display: "flex", flexDirection: "column" }}>
        {tool === "notepad" ? (
          <NotepadTool ref={notepadRef} notepadId={notepadId} onClose={handleClose} />
        ) : (
          <PaintTool ref={paintRef} paintId={paintId} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ToolModal;
